import { apiGet, apiPost, apiPut, apiDelete, apiPostFile } from './api'
import type { Issue, IssueCreate, IssueUpdate, IssuePhoto } from '../types'

export const issueApi = {
  getAll(filters?: { projectId?: string; status?: string; priority?: string; type?: string; category?: string; phase?: string }): Promise<Issue[]> {
    const params = new URLSearchParams()
    if (filters?.projectId) params.set('projectId', filters.projectId)
    if (filters?.status) params.set('status', filters.status)
    if (filters?.priority) params.set('priority', filters.priority)
    if (filters?.type) params.set('type', filters.type)
    if (filters?.category) params.set('category', filters.category)
    if (filters?.phase) params.set('phase', filters.phase)
    const query = params.toString()
    return apiGet<Issue[]>(`/issues${query ? `?${query}` : ''}`)
  },

  getByProject(projectId: string): Promise<Issue[]> {
    return apiGet<Issue[]>(`/issues/project/${projectId}`)
  },

  getById(id: string): Promise<Issue> {
    return apiGet<Issue>(`/issues/${id}`)
  },

  getNextNumber(projectId: string): Promise<{ issueNumber: string }> {
    return apiGet<{ issueNumber: string }>(`/issues/next-number/${projectId}`)
  },

  create(data: IssueCreate): Promise<Issue> {
    return apiPost<Issue>('/issues', data)
  },

  update(id: string, data: IssueUpdate): Promise<Issue> {
    return apiPut<Issue>(`/issues/${id}`, data)
  },

  delete(id: string): Promise<void> {
    return apiDelete(`/issues/${id}`)
  },

  bulkUpdate(ids: number[], updates: { status?: string; priority?: string; assignedTo?: string | null }): Promise<{ updated: number }> {
    return apiPut<{ updated: number }>('/issues/bulk', { ids, ...updates })
  },

  uploadPhoto(issueId: string, file: File, photoType?: string, caption?: string): Promise<IssuePhoto> {
    return apiPostFile<IssuePhoto>(`/issues/${issueId}/photos`, file, 'file', { photoType, caption })
  },

  getPhotos(issueId: string): Promise<IssuePhoto[]> {
    return apiGet<IssuePhoto[]>(`/issues/${issueId}/photos`)
  },

  deletePhoto(issueId: string, photoId: string): Promise<void> {
    return apiDelete(`/issues/${issueId}/photos/${photoId}`)
  },

  getPhotoUrl(issueId: string | number, photoId: number): string {
    const apiBase = import.meta.env.VITE_API_URL || '/api'
    return `${apiBase}/issues/${issueId}/photos/${photoId}/file`
  },
}
